export default {
    topics: [
        {
            title: ' appendChild ',
            href: 'm-DOMNode-appendChild.html',
            attributes: { 'data-id': 'm-DOMNode-appendChild' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-appendChild-d66e7072',
            topics: [],
        },
        {
            title: ' attributes ',
            href: 'p-DOMNode-attributes.html',
            attributes: { 'data-id': 'p-DOMNode-attributes' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-attributes-d66e7080',
            topics: [],
        },
        {
            title: ' baseURI ',
            href: 'p-DOMNode-baseURI.html',
            attributes: { 'data-id': 'p-DOMNode-baseURI' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-baseURI-d66e7088',
            topics: [],
        },
        {
            title: ' childNodes ',
            href: 'p-DOMNode-childNodes.html',
            attributes: { 'data-id': 'p-DOMNode-childNodes' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-childNodes-d66e7096',
            topics: [],
        },
        {
            title: ' firstChild ',
            href: 'p-DOMNode-firstChild.html',
            attributes: { 'data-id': 'p-DOMNode-firstChild' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-firstChild-d66e7104',
            topics: [],
        },
        {
            title: ' hasAttributes ',
            href: 'm-DOMNode-hasAttributes.html',
            attributes: { 'data-id': 'm-DOMNode-hasAttributes' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-hasAttributes-d66e7112',
            topics: [],
        },
        {
            title: ' hasChildNodes ',
            href: 'm-DOMNode-hasChildNodes.html',
            attributes: { 'data-id': 'm-DOMNode-hasChildNodes' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-hasChildNodes-d66e7120',
            topics: [],
        },
        {
            title: ' insertBefore ',
            href: 'm-DOMNode-insertBefore.html',
            attributes: { 'data-id': 'm-DOMNode-insertBefore' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-insertBefore-d66e7128',
            topics: [],
        },
        {
            title: ' isDefaultNamespace ',
            href: 'm-DOMNode-isDefaultNamespace.html',
            attributes: { 'data-id': 'm-DOMNode-isDefaultNamespace' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-isDefaultNamespace-d66e7136',
            topics: [],
        },
        {
            title: ' isEqualNode ',
            href: 'm-DOMNode-isEqualNode.html',
            attributes: { 'data-id': 'm-DOMNode-isEqualNode' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-isEqualNode-d66e7144',
            topics: [],
        },
        {
            title: ' isSameNode ',
            href: 'm-DOMNode-isSameNode.html',
            attributes: { 'data-id': 'm-DOMNode-isSameNode' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-isSameNode-d66e7153',
            topics: [],
        },
        {
            title: ' lastChild ',
            href: 'p-DOMNode-lastChild.html',
            attributes: { 'data-id': 'p-DOMNode-lastChild' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-lastChild-d66e7161',
            topics: [],
        },
        {
            title: ' localName ',
            href: 'p-DOMNode-localName.html',
            attributes: { 'data-id': 'p-DOMNode-localName' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-localName-d66e7169',
            topics: [],
        },
        {
            title: ' lookupNamespaceURI ',
            href: 'm-DOMNode-lookupNamespaceURI.html',
            attributes: { 'data-id': 'm-DOMNode-lookupNamespaceURI' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-lookupNamespaceURI-d66e7177',
            topics: [],
        },
        {
            title: ' namespaceURI ',
            href: 'p-DOMNode-namespaceURI.html',
            attributes: { 'data-id': 'p-DOMNode-namespaceURI' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-namespaceURI-d66e7185',
            topics: [],
        },
        {
            title: ' nextSibling ',
            href: 'p-DOMNode-nextSibling.html',
            attributes: { 'data-id': 'p-DOMNode-nextSibling' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-nextSibling-d66e7193',
            topics: [],
        },
        {
            title: ' nodeName ',
            href: 'p-DOMNode-nodeName.html',
            attributes: { 'data-id': 'p-DOMNode-nodeName' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-nodeName-d66e7201',
            topics: [],
        },
        {
            title: ' nodeType ',
            href: 'p-DOMNode-nodeType.html',
            attributes: { 'data-id': 'p-DOMNode-nodeType' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-nodeType-d66e7209',
            topics: [],
        },
        {
            title: ' nodeValue ',
            href: 'p-DOMNode-nodeValue.html',
            attributes: { 'data-id': 'p-DOMNode-nodeValue' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-nodeValue-d66e7217',
            topics: [],
        },
        {
            title: ' normalize ',
            href: 'm-DOMNode-normalize.html',
            attributes: { 'data-id': 'm-DOMNode-normalize' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-normalize-d66e7225',
            topics: [],
        },
        {
            title: ' ownerDocument ',
            href: 'p-DOMNode-ownerDocument.html',
            attributes: { 'data-id': 'p-DOMNode-ownerDocument' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-ownerDocument-d66e7233',
            topics: [],
        },
        {
            title: ' parentNode ',
            href: 'p-DOMNode-parentNode.html',
            attributes: { 'data-id': 'p-DOMNode-parentNode' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-parentNode-d66e7242',
            topics: [],
        },
        {
            title: ' prefix ',
            href: 'p-DOMNode-prefix.html',
            attributes: { 'data-id': 'p-DOMNode-prefix' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-prefix-d66e7250',
            topics: [],
        },
        {
            title: ' previousSibling ',
            href: 'p-DOMNode-previousSibling.html',
            attributes: { 'data-id': 'p-DOMNode-previousSibling' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-previousSibling-d66e7258',
            topics: [],
        },
        {
            title: ' removeChild ',
            href: 'm-DOMNode-removeChild.html',
            attributes: { 'data-id': 'm-DOMNode-removeChild' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-removeChild-d66e7266',
            topics: [],
        },
        {
            title: ' replaceChild ',
            href: 'm-DOMNode-replaceChild.html',
            attributes: { 'data-id': 'm-DOMNode-replaceChild' },
            menu: { hasChildren: false },
            tocID: 'm-DOMNode-replaceChild-d66e7274',
            topics: [],
        },
        {
            title: ' textContent ',
            href: 'p-DOMNode-textContent.html',
            attributes: { 'data-id': 'p-DOMNode-textContent' },
            menu: { hasChildren: false },
            tocID: 'p-DOMNode-textContent-d66e7282',
            topics: [],
        },
    ],
};

